import type { GetCustomerBalanceRequest, GetTransactionHistoryRequest, GetLoyaltyPolicyRequest } from './types';

export const LOYALTY_QUERY_KEYS = {
  default: () => ['loyalty'] as const,
  getCustomerBalance: ({ customerId, currency }: GetCustomerBalanceRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'balance', customerId, currency] as const,
  getTransactionHistory: ({ customerId, limit, lastEvaluatedKey, currency }: GetTransactionHistoryRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'transactions', customerId, limit, lastEvaluatedKey, currency] as const,
  getLoyaltyPolicy: ({ currency }: GetLoyaltyPolicyRequest) =>
    [...LOYALTY_QUERY_KEYS.default(), 'policy', currency] as const,
};
